import React, { useState, useEffect, useRef, useMemo } from "react";
import { createPortal } from "react-dom";
import { _Api } from "../api/_call";
import { ReportMenuModal } from "../common/modules/reportMenu";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Pagination } from "../common/Pagination";
import { formatDate } from "../common/helpers/formatDate";
import { loading, Updateloading } from "../common/helpers/toastify";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Select from "react-select";
import "./report.scss";

const REPORT_STATUSES = [2, 3, 4];

const STATUS_LABEL = {
  2: "Reserve",
  3: "Custom Order",
  4: "Transit",
};

const STATUS_DOT_CLASS = {
  2: "status-yellow light-yellow-bg",
  3: "status-yellow bg-danger",
  4: "status-gray-tab light-gray-bg",
};

// const idsOf = (list) => (list || []).map((item) => item?._id);
// const toRange = (range) => [Number(range?.min) || 0, Number(range?.max) || 0];

// const toApiDate = (date) => {
//   const now = new Date();
//   return new Date(
//     date.getFullYear(),
//     date.getMonth(),
//     date.getDate(),
//     now.getHours(),
//     now.getMinutes(),
//     now.getSeconds(),
//     now.getMilliseconds()
//   ).toISOString();
// };

const toReportDate = (date) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T00:00:00.000Z`;
};

const toPriceNumber = (value) => {
  const n = Number(String(value ?? "").replace(/[^0-9.-]/g, ""));
  return Number.isFinite(n) ? n : 0;
};

const formatPrice = (value) => {
  if (value === undefined || value === null || value === "") return "";
  return `$${toPriceNumber(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const categoryText = (record) => {
  const list = Array.isArray(record?.Category) ? record.Category : [];
  const fromList = list
    .map((c) => (c && typeof c === "object" ? c.Category_name : ""))
    .filter(Boolean);
  return fromList.length ? fromList.join(", ") : record?.Category_name ?? "";
};

const customerOf = (item) => {
  const c =
    item?.customer ||
    item?.Customer ||
    item?.customer_name ||
    item?.Customer_name ||
    item?.customerName ||
    item?.CustomerName;
  if (c && typeof c === "object") return c.name || c.Name || c.customer_name || c.fullName || "";
  return c || "";
};

const remarkOf = (item) =>
  item?.reserveRemark ||
  item?.ReserveRemark ||
  item?.reserve_remark ||
  item?.Remark ||
  item?.remark ||
  "";

// const commentOf = (item) => {
//   const value =
//     item?.comment ??
//     item?.Comment ??
//     item?.comments ??
//     item?.Comments ??
//     "";
//   const text = value === undefined || value === null ? "" : String(value).trim();
//   return text || "-";
// };

const statusDateOf = (item) =>
  item?.reserveDate ||
  item?.ReserveDate ||
  item?.reserve_date ||
  item?.orderDate ||
  item?.order_date ||
  item?.deliveryDate ||
  item?.delivery_date ||
  item?.transitDate ||
  "";

const DiamondReport = () => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const datePickerRef = useRef(null);
  const requestIdRef = useRef(0);
  const stickyTopRef = useRef(null);
  const tableHeadScrollRef = useRef(null);
  const tableBodyScrollRef = useRef(null);
  const tableHeadTableRef = useRef(null);
  const tableBodyTableRef = useRef(null);
  const tableScrollSyncLock = useRef(false);
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const [filters, setFilters] = useState(null);
  const [items, setItems] = useState([]);
  const [totalResult, setTotalResult] = useState(0);
  const [counts, setCounts] = useState({});
  const [limit, setLimit] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [filtername, setFiltername] = useState("");
  const [loader, setLoader] = useState(false);
  const [datefilter, setDatefilter] = useState(() => {
    const today = new Date();
    return [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth() + 1, 0)];
  });
  const [datelable, setDatelable] = useState("ThisMonth");
  const [sortConfig, setSortConfig] = useState({ key: "", dir: "asc" });
  const [appliedFilters, setAppliedFilters] = useState({});
  const [openFilter, setOpenFilter] = useState(null);
  const [filterDraft, setFilterDraft] = useState([]);
  const [filterSearch, setFilterSearch] = useState("");
  const [filterMenuStyle, setFilterMenuStyle] = useState({});
  const filterMenuRef = useRef(null);
  const filterBtnRefs = useRef({});

  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 },
  ];

  const changeDates = (lable) => {
    const today = new Date();
    let start = null;
    let end = null;
    if (lable === "Today") {
      start = new Date();
      end = new Date();
    } else if (lable === "Yesterday") {
      start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
      end = start;
    } else if (lable === "7days") {
      start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
      end = new Date();
    } else if (lable === "30days") {
      start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30);
      end = new Date();
    } else if (lable === "ThisMonth") {
      start = new Date(today.getFullYear(), today.getMonth(), 1);
      end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    } else if (lable === "LastMonth") {
      start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      end = new Date(today.getFullYear(), today.getMonth(), 0);
    }
    setDatefilter([start, end]);
    setDatelable(lable);
  };

  const loadFilters = async () => {
    try {
      const res = await _Api({}, `api/v1/Inventory/diamond/getFilters`);
      if (res?.code === 200) setFilters(res.data || {});
    } catch (err) {
      console.log(err, "err");
    }
  };

  const getall = async (page = 1, nextLimit = limit, search = filtername) => {
    if (!filters) return;
    const f = filters;
    const requestId = ++requestIdRef.current;
    setLoader(true);
    try {
      const rangeOr = (range, fallbackMax) => {
        const min = Number(range?.min);
        const max = Number(range?.max);
        return [{ min: Number.isFinite(min) ? min : 0, max: Number.isFinite(max) && max ? max : fallbackMax }];
      };
      const payload = {
        search: search || "",
        Shape: [],
        CUT: [],
        Clarity: [],
        Stonecolor: [],
        Polish: [],
        Symmetry: [],
        fluorescence: [],
        Lbs: [],
        Price: rangeOr(f.Price, 10000),
        Carat: rangeOr(f.Carat, 5),
        Depth: rangeOr(f.Depth, 100),
        Table: rangeOr(f.Table, 100),
        Location: [],
        Status: REPORT_STATUSES,
        page,
        limit: nextLimit,
      };
      if (datefilter[0] && datefilter[1]) {
        payload.start_date = toReportDate(datefilter[0]);
        payload.end_date = toReportDate(datefilter[1]);
      }
      // const res = await _Api(payload, `api/v1/Inventory/diamond/getList`);
      const res = await _Api(payload, `api/v1/Inventory/diamond/getReport`);
      if (requestId !== requestIdRef.current) return;
      if (res?.code === 200) {
        const rows = (res.data || []).filter((d) => REPORT_STATUSES.includes(Number(d?.Status)));
        const countOf = (status) => rows.filter((d) => Number(d?.Status) === status).length;
        const total = Number(res.totalResult ?? res.total ?? res.count ?? rows.length) || 0;
        setItems(rows);
        setTotalResult(total);
        setCurrentPage(page);
        setCounts({
          reserve: res?.reserve ?? res?.reserveCount ?? countOf(2),
          customOrder: res?.customOrder ?? res?.customOrderCount ?? countOf(3),
          transit: res?.transit ?? res?.transitCount ?? countOf(4),
        });
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      if (requestId === requestIdRef.current) setLoader(false);
    }
  };

  useEffect(() => {
    loadFilters();
  }, []);

  useEffect(() => {
    if (datefilter[0] && datefilter[1]) getall(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, datefilter]);

  useEffect(() => {
    const el = stickyTopRef.current;
    if (!el) return undefined;
    const page = el.closest(".diamond-report-page");
    const apply = () => {
      if (!page) return;
      page.style.setProperty("--report-sticky-block-height", `${el.offsetHeight}px`);
    };
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(el);
    window.addEventListener("resize", apply);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", apply);
    };
  }, []);

  const syncTableScroll = (source) => {
    if (tableScrollSyncLock.current) return;
    const head = tableHeadScrollRef.current;
    const body = tableBodyScrollRef.current;
    if (!head || !body) return;
    tableScrollSyncLock.current = true;
    if (source === "head") body.scrollLeft = head.scrollLeft;
    else head.scrollLeft = body.scrollLeft;
    requestAnimationFrame(() => {
      tableScrollSyncLock.current = false;
    });
  };

  const shapeNameByLogo = useMemo(() => {
    const map = {};
    (filters?.Shape || []).forEach((s) => {
      if (s?.logo) map[s.logo] = s.name;
    });
    return map;
  }, [filters]);

  const columnText = (item, key) => {
    if (key === "status") return t(STATUS_LABEL[Number(item?.Status)] || "");
    if (key === "shape") return shapeNameByLogo[item?.Shape] || "";
    if (key === "carat") return String(item?.Carat ?? "");
    if (key === "colour") return String(item?.Colour ?? "");
    if (key === "clarity") return String(item?.Clarity ?? "");
    if (key === "cut") return String(item?.Cut ?? "");
    if (key === "polish") return String(item?.Polish ?? "");
    if (key === "symmetry") return String(item?.Symmetry ?? "");
    if (key === "gradedBy") return String(item?.GradedBy ?? "");
    if (key === "certification") return String(item?.Certification ?? "");
    if (key === "price") return formatPrice(item?.Price);
    if (key === "location") return String(item?.Location ?? "");
    if (key === "stockId") return String(item?.StockID ?? "");
    if (key === "customer") return customerOf(item);
    if (key === "remark") return remarkOf(item);
    // if (key === "comment") return commentOf(item);
    return "";
  };

  const visibleItems = useMemo(() => {
    let rows = items.filter((item) =>
      Object.entries(appliedFilters).every(([key, values]) => {
        if (!values?.length) return true;
        return values.includes(columnText(item, key));
      })
    );
    if (sortConfig.key) {
      rows = [...rows].sort((a, b) => {
        const cmp = columnText(a, sortConfig.key).localeCompare(columnText(b, sortConfig.key), undefined, { numeric: true });
        return sortConfig.dir === "desc" ? -cmp : cmp;
      });
    }
    return rows;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, shapeNameByLogo, appliedFilters, sortConfig]);

  const renderStatusDot = (item) => {
    const status = Number(item?.Status);
    const customer = customerOf(item);
    const date = statusDateOf(item);
    return (
      <div className={`${STATUS_DOT_CLASS[status] || "status-color bg-main-green"} tooltip-area-up`}>
        <span className="tooltip-area-up-text">
          {customer || date ? (
            <>
              {customer}
              {customer && date ? <br /> : null}
              {date ? formatDate(date) : null}
            </>
          ) : (
            t(STATUS_LABEL[status] || "")
          )}
        </span>
      </div>
    );
  };

  const columns = [
    { key: "status", label: "Status", className: "text-center", cell: (item) => renderStatusDot(item), text: (item) => t(STATUS_LABEL[Number(item?.Status)] || "") },
    {
      key: "shape",
      label: "Shape",
      cell: (item) => (
        <img
          src={item?.Shape ? item?.Shape : base_assets + "images/icon/camera_profile.png"}
          alt=""
          style={{ width: 28, height: 28, objectFit: "contain" }}
        />
      ),
      text: (item) => shapeNameByLogo[item?.Shape] || "",
    },
    { key: "carat", label: "Carat", cell: (item) => item?.Carat ?? "" },
    { key: "colour", label: "Colour", cell: (item) => item?.Colour ?? "" },
    { key: "clarity", label: "Clarity", cell: (item) => item?.Clarity ?? "" },
    { key: "cut", label: "Cut", cell: (item) => item?.Cut ?? "" },
    { key: "polish", label: "Polish", cell: (item) => item?.Polish ?? "" },
    { key: "symmetry", label: "Symmetry", cell: (item) => item?.Symmetry ?? "" },
    { key: "gradedBy", label: "Graded By", cell: (item) => item?.GradedBy ?? "" },
    {
      key: "certification",
      label: "Certification",
      cell: (item) =>
        item?.CertificationUrl ? (
          <a className="link-color" target="_blank" rel="noreferrer" href={item?.CertificationUrl}>
            {item?.Certification || ""}
          </a>
        ) : (
          item?.Certification || ""
        ),
      text: (item) => item?.Certification || "",
    },
    { key: "price", label: "Price", className: "text-end", noFilter: true, cell: (item) => formatPrice(item?.Price) },
    { key: "location", label: "Location", cell: (item) => item?.Location ?? "" },
    { key: "stockId", label: "Stock Id", cell: (item) => item?.StockID ?? "" },
    { key: "customer", label: "Customer", cell: (item) => customerOf(item) },
    { key: "remark", label: "Remark", noFilter: true, cell: (item) => remarkOf(item) },
    // { key: "comment", label: "Comment", noFilter: true, cell: (item) => commentOf(item) },
    // {
    //   key: "category",
    //   label: "Category",
    //   cell: (item) => (
    //     <span
    //       title={categoryText(item)}
    //       style={{ display: "block", maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
    //     >
    //       {categoryText(item)}
    //     </span>
    //   ),
    //   text: (item) => categoryText(item),
    // },
    // { key: "fluorescence", label: "Fluorescence", cell: (item) => item?.Fluoresence ?? item?.Fluorescence ?? "" },
    // { key: "depth", label: "Depth", cell: (item) => item?.Depth ?? "" },
    // { key: "table", label: "Table", cell: (item) => item?.Table ?? "" },
    // { key: "gridle", label: "Gridle", cell: (item) => item?.Gridle_name ?? "" },
    // { key: "culet", label: "Culet", cell: (item) => item?.Culet_name ?? "" },
    // {
    //   key: "measurement",
    //   label: "Measurements (Dimensions)",
    //   cell: (item) => (item?.Measurement ? `${item?.Measurement} mm` : ""),
    // },
    // { key: "stockId", label: "Stock Id", cell: (item) => item?.StockID ?? "" },
    // { key: "customJewelry", label: "Custom Jewelry", cell: (item) => item?.CustomJewelry ?? "" },
  ];

  const totalPrice = visibleItems.reduce((sum, item) => sum + toPriceNumber(item?.Price), 0);
  const totalPages = Math.ceil(totalResult / (Number(limit) || 1)) || 0;

  useEffect(() => {
    let frame = 0;
    const syncTableWidths = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const headTable = tableHeadTableRef.current;
        const bodyTable = tableBodyTableRef.current;
        if (!headTable || !bodyTable) return;
        const headThs = headTable.querySelectorAll("thead th");
        const bodyRow = bodyTable.querySelector("tbody tr");
        const count = headThs.length;
        if (!count) return;
        headTable.style.width = "max-content";
        bodyTable.style.width = "max-content";
        headTable.style.tableLayout = "auto";
        bodyTable.style.tableLayout = "auto";
        headThs.forEach((th) => {
          th.style.width = "";
          th.style.minWidth = "";
          th.style.maxWidth = "";
        });
        bodyTable.querySelectorAll("td, th").forEach((cell) => {
          cell.style.width = "";
          cell.style.minWidth = "";
          cell.style.maxWidth = "";
        });
        const widths = [];
        for (let i = 0; i < count; i += 1) {
          const hw = headThs[i].getBoundingClientRect().width;
          const bw = bodyRow?.children[i]?.getBoundingClientRect().width || 0;
          widths.push(Math.ceil(Math.max(hw, bw, 40)));
        }
        let total = widths.reduce((sum, w) => sum + w, 0);
        const containerWidth = Math.floor(
          tableBodyScrollRef.current?.clientWidth || tableHeadScrollRef.current?.clientWidth || 0
        );
        if (containerWidth > total && total > 0) {
          const scale = containerWidth / total;
          let used = 0;
          for (let i = 0; i < count; i += 1) {
            if (i === count - 1) widths[i] = Math.max(widths[i], containerWidth - used);
            else {
              widths[i] = Math.max(1, Math.floor(widths[i] * scale));
              used += widths[i];
            }
          }
          total = containerWidth;
        }
        headTable.style.tableLayout = "fixed";
        bodyTable.style.tableLayout = "fixed";
        headTable.style.width = `${total}px`;
        bodyTable.style.width = `${total}px`;
        for (let i = 0; i < count; i += 1) {
          const widthPx = `${widths[i]}px`;
          headThs[i].style.width = widthPx;
          headThs[i].style.minWidth = widthPx;
          headThs[i].style.maxWidth = widthPx;
          bodyTable.querySelectorAll(`tr > :nth-child(${i + 1})`).forEach((cell) => {
            cell.style.width = widthPx;
            cell.style.minWidth = widthPx;
            cell.style.maxWidth = widthPx;
          });
        }
      });
    };
    syncTableWidths();
    window.addEventListener("resize", syncTableWidths);
    const observer = new ResizeObserver(syncTableWidths);
    if (tableHeadScrollRef.current) observer.observe(tableHeadScrollRef.current);
    if (tableBodyScrollRef.current) observer.observe(tableBodyScrollRef.current);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", syncTableWidths);
      observer.disconnect();
    };
  }, [visibleItems, loader, columns.length]);

  const downloadexclsheet = () => {
    const header = ["#", ...columns.map((c) => t(c.label))];
    const body = visibleItems.map((item, index) => [
      index + 1,
      ...columns.map((c) => {
        const value = c.text ? c.text(item) : c.cell(item);
        return typeof value === "object" ? "" : value;
      }),
    ]);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(body, { origin: "A2", skipHeader: true });
    XLSX.utils.sheet_add_aoa(ws, [header], { origin: "A1" });
    XLSX.utils.book_append_sheet(wb, ws, "Records");
    const fileContent = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    FileSaver.saveAs(new Blob([fileContent], { type: fileType }), "report_diamond");
  };

  const optionsFor = (key) => {
    const values = new Set();
    items.forEach((item) => {
      const value = columnText(item, key);
      if (value) values.add(value);
    });
    return [...values].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
  };

  const placeFilterMenu = (key) => {
    const trigger = filterBtnRefs.current[key];
    if (!trigger) return;
    const rect = trigger.getBoundingClientRect();
    const menuWidth = 286;
    let left = rect.left;
    if (left + menuWidth + 8 > window.innerWidth) left = Math.max(8, window.innerWidth - menuWidth - 8);
    setFilterMenuStyle({ position: "fixed", top: rect.bottom + 6, left, width: menuWidth, zIndex: 3000 });
  };

  const openColumnFilter = (key) => {
    if (openFilter === key) {
      setOpenFilter(null);
      return;
    }
    setFilterDraft(appliedFilters[key] || []);
    setFilterSearch("");
    setOpenFilter(key);
    placeFilterMenu(key);
  };

  useEffect(() => {
    if (!openFilter) return undefined;
    const handleOutside = (event) => {
      const trigger = filterBtnRefs.current[openFilter];
      if (trigger?.contains(event.target) || filterMenuRef.current?.contains(event.target)) return;
      setOpenFilter(null);
    };
    const handleMove = () => placeFilterMenu(openFilter);
    document.addEventListener("mousedown", handleOutside);
    window.addEventListener("resize", handleMove);
    window.addEventListener("scroll", handleMove, true);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      window.removeEventListener("resize", handleMove);
      window.removeEventListener("scroll", handleMove, true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openFilter]);

  const getprint = async () => {
    const loadingId = loading();
    try {
      const payload = {
        search: filtername || "",
        Shape: [],
        CUT: [],
        Clarity: [],
        Stonecolor: [],
        Polish: [],
        Symmetry: [],
        fluorescence: [],
        Lbs: [],
        Price: [],
        Carat: [],
        Depth: [],
        Table: [],
        Location: [],
        Status: REPORT_STATUSES,
      };
      if (datefilter[0] && datefilter[1]) {
        payload.start_date = toReportDate(datefilter[0]);
        payload.end_date = toReportDate(datefilter[1]);
      }
      // const res = await _Api(payload, `api/v1/Inventory/inventory/print/diamondSearch`);
      const res = await _Api(payload, `api/v1/Inventory/inventory/print/diamondReport`);
      if (res.code === 200) {
        setTimeout(() => {
          const exportLinkElement = document.createElement("a");
          exportLinkElement.hidden = true;
          exportLinkElement.download = res?.name ? res?.name : "report.pdf";
          exportLinkElement.href = res?.link;
          exportLinkElement.text = "downloading...";
          exportLinkElement.setAttribute("target", "_blank");
          document.body.appendChild(exportLinkElement);
          exportLinkElement.click();
          exportLinkElement.remove();
          Updateloading(t, loadingId, t("download successfully"));
        }, 50);
      } else {
        Updateloading(t, loadingId, res?.message ? res?.message : res?.errors, "error");
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, loadingId, err, t("error"));
    }
  };

  const statCards = [
    { label: "Total Diamonds", value: totalResult, icon: "images/icons/free-stock.png", tone: "stock" },
    { label: "Reserve", value: counts.reserve ?? 0, icon: "images/icons/sku.png", tone: "sku" },
    { label: "Custom Order", value: counts.customOrder ?? 0, icon: "images/icons/customer.png", tone: "value" },
    { label: "Transit", value: counts.transit ?? 0, icon: "images/icons/location.png", tone: "location" },
  ];

  return (
    <React.Fragment>
      <div className="main-body report-page diamond-report-page product-tab-page-padding-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12" style={{ display: "flex", flexWrap: "wrap" }}>
              <div className="sticky-top-report-page" ref={stickyTopRef}>
              <h1 className="main-body-heading">
                <span>{t("report")} {">"}</span>&nbsp;&nbsp;{t("Diamond")}
              </h1>
              <div className="main-body-top-inventory">
                <div className="main-body-top-inventory-status">
                  {statCards.map((card) => (
                    <div className="main-body-top-inventory-status-card" key={card.label}>
                      <div className="left-side">
                        <img src={base_assets + card.icon} className="inventory-img" alt="" />
                      </div>
                      <div className="right-side">
                        <span className="inventory-name">{t(card.label)}</span>
                        <h2 className={`inventory-value ${card.tone}`}>{card.value || "0"}</h2>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="main-body-top-status-bar">
                <ReportMenuModal />
                <Select
                  className="limit-select short mx-3 z-10"
                  options={selectOptions}
                  value={{ label: limit, value: limit }}
                  onChange={(e) => {
                    setLimit(e.value);
                    getall(1, e.value);
                  }}
                />
                <div className="main-body-top-status-bar-filter">
                  <input
                    value={filtername}
                    type="text"
                    className="main-body-top-status-bar-filter-input"
                    placeholder={t("Search by Stock ID, Customer or Location")}
                    onChange={(e) => setFiltername(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && getall(1, limit, e.target.value)}
                  />
                  {filtername ? (
                    <img
                      className="main-body-top-status-bar-filter-clear"
                      src={base_assets + "images/icons/False.png"}
                      onClick={() => {
                        setFiltername("");
                        getall(1, limit, "");
                      }}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                  <button type="button" className="main-body-top-status-bar-filter-search" onClick={() => getall(1, limit, filtername)}>
                    <i className="fa fa-search" aria-hidden="true" />
                  </button>
                </div>
                <div className="main-body-top-status-bar-multi-date-picker">
                  <div className="main-body-top-status-bar-note-button common-dropdown replenish-date">
                    <button
                      className="dropdown-toggle btn-style align-items-center d-flex"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 4.66667V8L10.5 10.5M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      {t(datelable)}
                    </button>
                    <ul className="dropdown-menu dropdown-menu-right-fix" aria-labelledby="dropdownMenuButton1">
                      <li className={`dropdown-item ${datelable === "Today" ? "active" : ""}`} onClick={() => changeDates("Today")}>{t("Today")}</li>
                      <li className={`dropdown-item ${datelable === "Yesterday" ? "active" : ""}`} onClick={() => changeDates("Yesterday")}>{t("Yesterday")}</li>
                      <li className={`dropdown-item ${datelable === "7days" ? "active" : ""}`} onClick={() => changeDates("7days")}>{t("Last 7 days")}</li>
                      <li className={`dropdown-item ${datelable === "30days" ? "active" : ""}`} onClick={() => changeDates("30days")}>{t("Last 30 days")}</li>
                      <li className={`dropdown-item ${datelable === "ThisMonth" ? "active" : ""}`} onClick={() => changeDates("ThisMonth")}>{t("This Month")}</li>
                      <li className={`dropdown-item ${datelable === "LastMonth" ? "active" : ""}`} onClick={() => changeDates("LastMonth")}>{t("Last Month")}</li>
                      <li className={`dropdown-item ${datelable === "Custom Range" ? "active" : ""}`} onClick={() => datePickerRef.current.setOpen(true)}>{t("Custom Range")}</li>
                    </ul>
                    <DatePicker
                      selectsRange={true}
                      monthsShown={2}
                      startDate={datefilter[0]}
                      endDate={datefilter[1]}
                      onChange={(update) => {
                        setDatelable("Custom Range");
                        setDatefilter([update[0], update[1]]);
                      }}
                      dateFormat="yyyy-MM-dd"
                      ref={datePickerRef}
                      autoComplete="none"
                    />
                  </div>
                  <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                    <button className="btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <img src={base_assets + "images/icons/ellipsis-circular.png"} alt="" />
                    </button>
                    <ul className="dropdown-menu">
                      <li className={(parmissiondatashow?.inventory_reports?.Print || parmissiondatashow?.inventory_diamond_search?.Print) ? "dropdown-item print-dropdown-item" : "d-none"} onClick={getprint}>
                        <div className="dropdown-item-img">
                          <img src={base_assets + "images/icons/printer-icon.png"} alt="" />
                        </div>
                        <span>{t("print")}</span>
                      </li>
                      <li className="dropdown-item" onClick={downloadexclsheet}>
                        <div className="dropdown-item-img">
                          <img src={base_assets + "images/icons/export-x-icon.png"} alt="" />
                        </div>
                        <span>{t("export")}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              </div>
              <div
                className="main-body-main-table-wrap position-relative report-sticky-table-wrap"
                style={{ maxWidth: "100%", width: "100%", overflow: "visible" }}
              >
                <div className="report-sticky-thead">
                  <div
                    className="report-table-hscroll report-table-hscroll--head"
                    ref={tableHeadScrollRef}
                    onScroll={() => syncTableScroll("head")}
                  >
                    <table
                      ref={tableHeadTableRef}
                      className="stripe row-border order-column common-table table-striped main-table report-head-table"
                    >
                      <thead>
                        <tr>
                          <th className="diamond-report-th" style={{ fontWeight: 400 }}>#</th>
                          {columns.map((col) => (
                            <th
                              key={col.key}
                              className={`${col.className || ""} diamond-report-th`}
                              style={{ fontWeight: 400 }}
                            >
                              <span className="d-inline-flex align-items-center">
                                {t(col.label)}
                                {!col.noFilter && (
                                  <button
                                    type="button"
                                    className="after-none bg-transparent border-0 p-0"
                                    ref={(el) => {
                                      filterBtnRefs.current[col.key] = el;
                                    }}
                                    onClick={() => openColumnFilter(col.key)}
                                  >
                                    <img
                                      className="ms-2 com-custom-table-tag-filter-img"
                                      src={base_assets + "images/icons/table-filter-icon.png"}
                                      alt=""
                                    />
                                  </button>
                                )}
                              </span>
                            </th>
                          ))}
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
                <div
                  className="report-table-hscroll report-table-hscroll--body"
                  ref={tableBodyScrollRef}
                  onScroll={() => syncTableScroll("body")}
                >
                <table
                  id="report_diamond"
                  ref={tableBodyTableRef}
                  className="stripe row-border order-column common-table table-striped main-table w-100"
                >
                  <tbody>
                    {visibleItems.map((item, index) => (
                      <tr key={item?._id || index}>
                        <td>{(currentPage - 1) * (Number(limit) || 0) + index + 1}</td>
                        {columns.map((col) => (
                          <td key={col.key} className={col.className || ""}>{col.cell(item)}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                  {visibleItems.length > 0 && (
                    <tfoot>
                      <tr>
                        <td>{t("Total")}</td>
                        {columns.map((col) => (
                          <td key={col.key} className={col.className || ""}>
                            {col.key === "price" ? formatPrice(totalPrice) : ""}
                          </td>
                        ))}
                      </tr>
                    </tfoot>
                  )}
                </table>
                </div>
                {!loader && !visibleItems.length && (
                  <div className="text-center my-4">{t("No data available in table")}</div>
                )}
                <div id="table_loader" className={loader ? "mt-4" : "d-none"}>
                  <div className="dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
              {totalPages > 1 ? (
                <Pagination total={totalPages} current={currentPage} pagination={(page) => getall(page)} />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      {openFilter && createPortal(
        (() => {
          const options = optionsFor(openFilter);
          const shown = filterSearch
            ? options.filter((value) => value.toLowerCase().includes(filterSearch.toLowerCase()))
            : options;
          return (
            <div
              ref={filterMenuRef}
              className="dropdown-menu show com-custom-table-tag-filter-menu dtbs-filter-dropdown-menu dtbs-filter-portal-menu p-0 border-0 overflow-hidden"
              style={filterMenuStyle}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="asc-des-order">
                <div className="asc-des-order-single cursor-pointer" onClick={() => { setSortConfig({ key: openFilter, dir: "asc" }); setOpenFilter(null); }}>
                  <img src={base_assets + "images/icons/arrow-sort-up.png"} alt="" />
                  {t("Sort Ascending")}
                </div>
                <div className="asc-des-order-single cursor-pointer" onClick={() => { setSortConfig({ key: openFilter, dir: "desc" }); setOpenFilter(null); }}>
                  <img src={base_assets + "images/icons/arrow-sort-down.png"} alt="" />
                  {t("Sort Descending")}
                </div>
              </div>
              <div className="com-custom-table-tag-filter-menu-search">
                <div className="com-custom-table-tag-filter-menu-search-inner d-flex align-items-center">
                  <img src={base_assets + "images/icons/search-icon.png"} alt="" />
                  <input
                    className="border-0"
                    type="text"
                    placeholder={t("Search")}
                    value={filterSearch}
                    onChange={(e) => setFilterSearch(e.target.value)}
                  />
                </div>
              </div>
              <div className="com-custom-table-tag-filter-menu-select">
                <div className="com-custom-table-tag-filter-menu-select-bar d-flex align-items-center justify-content-between">
                  <div>
                    <input
                      className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer"
                      type="checkbox"
                      id="diamond-report-filter-all"
                      checked={options.length > 0 && filterDraft.length === options.length}
                      onChange={(e) => setFilterDraft(e.target.checked ? options : [])}
                    />
                    <label className="form-check-label cursor-pointer fw-semibold" htmlFor="diamond-report-filter-all">
                      {t("Select All")}
                    </label>
                  </div>
                  <label>{filterDraft.length}/{options.length} {t("Selected")}</label>
                </div>
                <ul className="com-custom-table-tag-filter-menu-select-list list-unstyled mt-3 ps-4">
                  {shown.map((value, index) => (
                    <li className="com-custom-table-tag-filter-menu-select-list-single" key={`${value}-${index}`}>
                      <input
                        className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer"
                        type="checkbox"
                        id={`diamond-report-filter-${index}`}
                        checked={filterDraft.includes(value)}
                        onChange={(e) => setFilterDraft((prev) => (e.target.checked ? [...prev, value] : prev.filter((v) => v !== value)))}
                      />
                      <label className="form-check-label cursor-pointer" htmlFor={`diamond-report-filter-${index}`}>
                        {value}
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="com-custom-table-tag-filter-menu-btn-grp text-center d-flex align-items-center gap-2">
                <button
                  type="button"
                  className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 bg-transparent fw-semibold graythemecolor"
                  onClick={() => {
                    setFilterDraft([]);
                    setFilterSearch("");
                    setAppliedFilters((prev) => {
                      const next = { ...prev };
                      delete next[openFilter];
                      return next;
                    });
                  }}
                >
                  {t("Clear")}
                </button>
                <button
                  type="button"
                  className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 main-green-bg text-white fw-semibold"
                  onClick={() => {
                    setAppliedFilters((prev) => {
                      const next = { ...prev };
                      if (filterDraft.length) next[openFilter] = filterDraft;
                      else delete next[openFilter];
                      return next;
                    });
                    setOpenFilter(null);
                  }}
                >
                  {t("Apply")}
                </button>
              </div>
            </div>
          );
        })(),
        document.body
      )}
    </React.Fragment>
  );
};

export default DiamondReport;
